import React from "react";
import formatter from "../../../utils/formatter";
import {
  PaymentCardWrapper,
  PaymentInfoContent,
  PaymentContentWrapper,
  PaymentDivider,
  PaymentAmount
} from "./styles";

export const remainingAmountFun = (remainingAmount) => {
  const amount = formatter({
    value: remainingAmount,
    fieldSuffix: "Dollars"
  })
  let displayAmount = "$0.00"
  if(remainingAmount > 0){
    displayAmount = amount;
  }else if(remainingAmount < 0){
    displayAmount = `-${amount}`;
  }else{
    displayAmount = "$0.00";
  }
  return displayAmount;
}

function PaymentInfoCard(props) {
  const { totalAmount, remainingAmount } = props;

  return (
    <PaymentCardWrapper>
      <PaymentContentWrapper>
        <PaymentInfoContent>Total grant amount:</PaymentInfoContent>
        <PaymentAmount>
          {totalAmount
            ? formatter({
                value: totalAmount,
                fieldSuffix: "Dollars"
              })
            : "$0.00"}
        </PaymentAmount>
        <PaymentDivider />
        <PaymentInfoContent>Remaining amount: </PaymentInfoContent>
        <PaymentAmount>
          {remainingAmountFun(remainingAmount)}
        </PaymentAmount>
      </PaymentContentWrapper>
    </PaymentCardWrapper>
  );
}

export default PaymentInfoCard;
